angular.module('app.services').service('dictionaryItemsService', function (api) {
    const Service = this;

    Service.selectize = (dictionaryName) =>
        api(`dictionaries/${dictionaryName}`)
            .selectize()
            .then((response) => response.data);
});
